import { multiplyQuantity } from "../components/change-quantity";
import { updateTotalPrice } from "../components/related-products";
import { $Q } from "./query-selector";

export const productQuantitySelector = (parent) => {
  parent ? parent : document
  const quantityContainer = $Q('.quantity__container', parent);

  if (quantityContainer) {
    const quantityInput = $Q('input', quantityContainer);
    const max = quantityInput.max;

    quantityContainer.addEventListener("click", (e) => {      
      if (e.target.classList.contains("btn-less") && quantityInput.value <= 1) return;

      if (e.target.classList.contains("btn-plus")) {
        if (max && quantityInput.value === max) return;
        quantityInput.value ++;
      } else if (e.target.classList.contains("btn-less") && quantityInput.value > 1) {
        quantityInput.value --;
      }

      return quantityInput.dispatchEvent(new Event('change'))
    })

    quantityInput.addEventListener("change", () => {
      updateTotalPrice();
      multiplyQuantity(parent, quantityInput.value);
    });
  }
}
